import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

interface DeleteData {
  users: any;
  title: string;
  appName: string;
}
@Component({
  standalone: false,
  selector: 'app-delete-user-dialog',
  templateUrl: './delete-user-dialog.component.html',
  styleUrls: ['./delete-user-dialog.component.scss']
})
export class DeleteUserDialogComponent {
  tableColumns = [
    { property: 'name', title: 'Name' },
    { property: 'email', title: 'Email' },
    { property: 'roles', title: 'Role' }
  ];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DeleteData,
    public dialogRef: MatDialogRef<DeleteUserDialogComponent>
  ) {}

  close() {
    this.dialogRef.close();
  }
}
